module.exports = __webpack_public_path__ + "static/img/1.1fa7a10.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/zh/1.png
// module id = 3pEZ
// module chunks = 0